export const FullVideo = (() => {
	'use strict';

	function init() {
		document.querySelectorAll('.pxblock--full-video .video-container').forEach((videoContainer) => {
			const innerIframe = videoContainer.querySelector('iframe');

			if (!innerIframe) return;

			const iframeClone = innerIframe.cloneNode(true);

			iframeClone.src = iframeClone.src.replace('feature=oembed', 'feature=oembed&autoplay=1');

			videoContainer.addEventListener('click', (ev) => {
				videoContainer.classList.add('video-active');
				videoContainer.appendChild(iframeClone);

				iframeClone.requestFullscreen();
			});
		});

	}

	return {
		init: init,
		name: 'full-video',
	};
})();
